import {
    container,
    title,
    main,
    mainRaised,
    mrAuto,
    whiteColor,
    infoColor,
    mlAuto,
} from "assets/jss/material-kit-pro-react.js";

const landingPageStyle = {
    main,
    mainRaised,
    mrAuto,
    mlAuto,
    landingPageMainRaised: {
        "@media (max-width: 830px)": {
            marginLeft: "10px",
            marginRight: "10px",
        },
        margin: "0px 0px 0px 0px",
        height: "100vh",
        display: "flex",
        justifyContent: "center", /* horizontal centering */
        alignItems: "center",     /* vertical centering */
    },
    container: {
        ...container,
        zIndex: 2,
    },
    title: {
        ...title,
        "&, & + h4": {
            color: infoColor[1],
        },
    },
    paddingY: {
        "@media (max-width: 576px)": {
            padding: "20px 0",
          },
        padding: "80px 0",
    },
    textCenter: {
        textAlign: "center",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right",
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    },



};



export default landingPageStyle;
